import { Link } from "react-router-dom";
import { Phone, EnvelopeSimple, MapPin, WhatsappLogo, FacebookLogo, InstagramLogo, LinkedinLogo, DeviceMobile } from "@phosphor-icons/react";
import { CONTACT, NAV, DOMESTIC_STATES, INTERNATIONAL } from "@/data/site";

export default function Footer() {
  return (
    <footer className="bg-brand-navy text-white/80 relative overflow-hidden" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 md:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <div className="bg-white rounded-xl p-3 inline-block">
            <img src="/assets/cluetrip-logo.png" alt="Cluetrip Holidays" className="h-12 w-auto" />
          </div>
          <p className="mt-5 text-sm leading-relaxed text-white/70 font-body">
            Travel to live, Live to Travel. Handcrafted holidays across India & the world.
          </p>
          <div className="mt-5 flex gap-3">
            <a href={CONTACT.socials.facebook} target="_blank" rel="noreferrer" aria-label="Facebook" data-testid="footer-facebook" className="flex h-9 w-9 items-center justify-center rounded-full bg-white/10 hover:bg-brand-orange transition-colors"><FacebookLogo size={18} weight="fill" /></a>
            <a href={CONTACT.socials.instagram} target="_blank" rel="noreferrer" aria-label="Instagram" data-testid="footer-instagram" className="flex h-9 w-9 items-center justify-center rounded-full bg-white/10 hover:bg-brand-orange transition-colors"><InstagramLogo size={18} weight="fill" /></a>
            <a href={CONTACT.socials.linkedin} target="_blank" rel="noreferrer" aria-label="LinkedIn" data-testid="footer-linkedin" className="flex h-9 w-9 items-center justify-center rounded-full bg-white/10 hover:bg-brand-orange transition-colors"><LinkedinLogo size={18} weight="fill" /></a>
          </div>
        </div>

        <div>
          <h4 className="text-white text-sm font-accent font-bold uppercase tracking-[0.2em] mb-5">Explore</h4>
          <ul className="space-y-3 text-sm">
            {NAV.map((n) => (
              <li key={n.label}><Link to={n.to} className="hover:text-brand-orange transition-colors">{n.label}</Link></li>
            ))}
            <li><Link to="/track" className="hover:text-brand-orange transition-colors" data-testid="footer-track">Track Booking</Link></li>
            <li><Link to="/pay" className="hover:text-brand-orange transition-colors">Pay Now</Link></li>
            <li><Link to="/admin" className="hover:text-brand-orange transition-colors">Admin</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white text-sm font-accent font-bold uppercase tracking-[0.2em] mb-5">Destinations</h4>
          <p className="text-sm text-white/70 leading-relaxed">
            {[...DOMESTIC_STATES.slice(0, 5), ...INTERNATIONAL.slice(0, 5)].join(" · ")}
          </p>
        </div>

        <div>
          <h4 className="text-white text-sm font-accent font-bold uppercase tracking-[0.2em] mb-5">Reach Us</h4>
          <ul className="space-y-4 text-sm">
            <li className="flex gap-3"><MapPin size={20} className="text-brand-orange shrink-0 mt-0.5" /><span>{CONTACT.address}</span></li>
            <li className="flex gap-3"><Phone size={20} className="text-brand-orange shrink-0 mt-0.5" />
              <span className="flex flex-col gap-1">
                {CONTACT.phones.map((p) => (
                  <a key={p} href={`tel:${p.replace(/\s/g, "")}`} className="hover:text-brand-orange">{p}</a>
                ))}
              </span>
            </li>
            <li className="flex gap-3"><DeviceMobile size={20} className="text-brand-orange shrink-0" /><a href={`tel:${CONTACT.landline.replace(/-/g, "")}`} className="hover:text-brand-orange">{CONTACT.landline} (Landline)</a></li>
            <li className="flex gap-3"><EnvelopeSimple size={20} className="text-brand-orange shrink-0 mt-0.5" />
              <span className="flex flex-col gap-1">
                {CONTACT.emails.map((e) => (
                  <a key={e} href={`mailto:${e}`} className="hover:text-brand-orange break-all">{e}</a>
                ))}
              </span>
            </li>
            <li className="flex gap-3"><WhatsappLogo size={20} className="text-brand-orange shrink-0" /><a href={`https://wa.me/${CONTACT.whatsapp}`} target="_blank" rel="noreferrer" className="hover:text-brand-orange">WhatsApp us</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 md:px-10 py-6 flex flex-col md:flex-row justify-between gap-2 text-xs text-white/50">
          <span>© {new Date().getFullYear()} Cluetrip Holidays Pvt. Ltd. All rights reserved.</span>
          <span>cluetrip.co.in</span>
        </div>
      </div>
    </footer>
  );
}
